
import { FieldTextStateless } from '@atlaskit/field-text';
import React from 'react';
import { connect } from 'react-redux';

import { Dialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import AbstractdonorboxDialog, {
    type Props as AbstractProps,
    mapDispatchToProps as abstractmapDispatchToProps
} from '../AbstractdonorboxDialog';

type Props = AbstractProps & {

    /**
     * Invoked to obtain translated strings.
     */
    t: Function,

    /**
     * The URL of the Donorbox.
    */
    _addUrldialog: Function,

    /**
     * Dispatches a error notificatio.
    */
   _addErrorNotification: Function

};

/**
 * The donorbox application.
 */
class donorboxDialog extends AbstractdonorboxDialog<Props> {


    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
    */
    render() {
        const { t } = this.props;

        return (
            <Dialog
                okKey = 'dialog.linkDonorBox'
                onSubmit = { this._onSubmitWeb }
                titleKey = 'donorbox.title'
                width = 'small'>
                <div className = 'modal-dialog-donor'>
                    <FieldTextStateless
                        autoFocus = { true }
                        isInvalid = { this.state.url ? Boolean(this.state.url) : false }
                        isSpellCheckEnabled = { false }
                        label = { t('dialog.donationLabel') }
                        name = 'donorID'
                        okDisabled = { false }

                        onChange = { e => {
                            this.setState({ textc: e.target.value });
                        } }
                        placeholder = { t('dialog.enterDonation') }
                        required = { true }
                        shouldFitContainer = { true }
                        type = 'text' />
                    {
                        this.state.url
                            ? <span className = 'warning-text'>
                                { t('donorbox.errorNotification') }
                            </span>
                            : null
                    }
                </div>
            </Dialog>
        );

    }


    _onSubmitWeb: () => boolean;
}

// https://donorbox.org/donation-help-cabs-drivers-to-feed-their-loved-ones
/**
* Redux _mapDispatchToProps .
*
* @param {number} dispatch - The Function.
* @returns  {string} For the donorbox url.
*/
export function _mapDispatchToProps(dispatch: Function): Object {
    return {
        ...abstractmapDispatchToProps(dispatch)

    };
}


export default translate(connect(null, _mapDispatchToProps)(donorboxDialog));
